module.exports = __webpack_public_path__ + "2d55a34585277dcd0d4e96f514bff29b.mp4";